import React from 'react';
import { ScrollHandler } from 'react-virtualized';
import { useAutocompleteContext } from '../AutocompleteBase';
import ListBox from './ListBox';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onOptionsListScroll?: ScrollHandler;
  loading?: boolean;
}

const ListBoxWithAutocomplete = React.forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>, ref) => {
    const { onOptionsListScroll, loading, isGrouped } = useAutocompleteContext();

    return (
      <ListBox
        ref={ref}
        children={children}
        onOptionsListScroll={onOptionsListScroll}
        loading={loading}
        isGrouped={isGrouped}
        data-test-id='autocomplete-list-box'
        {...props}
      />
    );
  }
);

export default ListBoxWithAutocomplete;